<template>
  <b-modal ref="formModal" :hideFooter="true" size="lg" :title="modalTitle" @hidden="onHide">

    <div class="row">
      <div class="col-12 m-form m-form--state">

        <photo-upload class="mb-4" ref="photoUpload" :initialPhoto="user.photo" @photoUpdated="userPhotoUpdated"></photo-upload>

        <div class="form-group" v-bValidate="{ 'errors' : errors, 'name' : 'name' }">
          <label for="name">Name</label>
          <input type="text" id="name" v-model="user.name" class="form-control" placeholder="Name">
        </div>
        <div class="form-group" v-bValidate="{ 'errors' : errors, 'name' : 'tagline' }">
          <label for="tagline">Tagline</label>
          <input type="text" id="tagline" v-model="user.tagline" class="form-control" placeholder="Tagline">
        </div>
        <div class="form-group" v-bValidate="{ 'errors' : errors, 'name' : 'email' }">
          <label for="email">Email</label>
          <input type="email" id="email" v-model="user.email" class="form-control" placeholder="Email">
        </div>
        <div class="form-group" v-bValidate="{ 'errors' : errors, 'name' : 'password' }">
          <label for="password">Password</label>
          <input type="password" id="password" v-model="user.password" class="form-control" placeholder="Password" autocomplete="off">
        </div>
        <div class="form-group" v-bValidate="{ 'errors' : errors, 'name' : 'role_id' }">
          <label for="role_id">Role</label>
          <select id="role_id" v-model="user.role_id" class="form-control">
            <option :value="role.id" v-for="role in roles">{{ role.title }}</option>
          </select>
        </div>
        <div class="form-group" v-bValidate="{ 'errors' : errors, 'name' : 'hide_from_dashboard' }">
          <label for="hide_from_dashboard">Hide from dashboard?</label>
          <input id="hide_from_dashboard" type="checkbox" v-model="user.hide_from_dashboard">
        </div>
        <div class="form-group" v-bValidate="{ 'errors' : errors, 'name' : 'hide_from_app' }">
          <label for="hide_from_app">Hide from app?</label>
          <input id="hide_from_app" type="checkbox" v-model="user.hide_from_app">
        </div>

        <div class="text-center mt-3">
          <div class="btn btn-brand mr-1" @click="submit()">{{ isEdit ? 'Update' : 'Create' }}</div>
          <div class="btn btn-metal" @click="hide()">Cancel</div>
        </div>

      </div>
    </div>

  </b-modal>
</template>
<script>
  import bModal from 'bootstrap-vue/src/components/modal/modal'
  import PhotoUpload from './PhotoUplaod'

  export default {
    components: {
      'b-modal': bModal,
      'photo-upload': PhotoUpload,
    },
    created() {
      this.axios.get('/roles').then(response => {
        this.roles = response.data.data
      })
      this.loadUser()
    },
    data() {
      return {
        user: {},
        roles: [],
        errors: false,
        modalTitle: 'Create new resource',
      }
    },
    computed: {
      isEdit() {
        return this.user.id
      },
    },
    methods: {
      loadUser() {
        this.user = {

          id: null,
          name: null,
          tagline: null,
          email: null,
          role_id: 3,
          password: null,
          hide_from_dashboard: false,
          hide_from_app: false,
        }
      },
      onHide() {
        this.loadUser();
        this.errors = false;
      },
      hide() {
        this.$refs.formModal.hide();
      },
      submit() {
        if (this.isEdit) {
          this.update()
        } else {
          this.store()
        }
      },
      create() {
        this.modalTitle = 'Create new resource'
        this.$refs.formModal.show();
      },
      edit(user) {
        this.modalTitle = 'Edit - ' + user.name

        Object.assign(this.user, user)
        this.$refs.formModal.show();
      },
      store() {
        this.axios.post('/users', this.user).then(response => {
          if (response.status === 201) {
            this.$refs.photoUpload.submit(response.data.data.id)
            this.$emit('userCreated', response.data.data)
            this.$root.$emit('create-success', response.data.data)
            this.hide()
          }
        }).catch(err => {
          if (err.response.data && err.response.data.errors) {
            this.errors = err.response.data.errors
          }
        })
      },
      update() {
        this.axios.put('/users/' + this.user.id, this.user).then(response => {
          if (response.status === 202) {
            this.$refs.photoUpload.submit(response.data.data.id)
            this.$emit('userUpdated', response.data.data)
            this.$root.$emit('update-success', response.data.data)
            this.hide()
          }
        }).catch(err => {
          if (err.response.data && err.response.data.errors) {
            this.errors = err.response.data.errors
          }
        })
      },
      userPhotoUpdated(data) {
        this.$emit('userPhotoUpdated', data)
      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/views/users/UserForm.vue